import { useContext } from 'react';

import AuthenticationContext from './AuthenticationContext';

const useAuthenticationContext = () => {
  const context = useContext(AuthenticationContext);
  if (!context) {
    throw new Error('useAuthenticationContext must be a child of MainProvider');
  }
  return { ...useContext(AuthenticationContext) };
};
export default useAuthenticationContext;
